// import { FC, memo } from "react";

// interface GenericTableProps {
//   data: Record<string, any>[];
// }

// const GenericTable: FC<GenericTableProps> = ({ data }) => {
//   // if (!data || data.length < 0) {
//   //   return <p>No data found</p>;
//   // }

//   const headers = Object.keys(data[0]);

//   // Header format: snake_case -> First Letter Capital (Title Case)
//   const formatHeader = (header: string) => {
//     return header
//       .replace(/_/g, " ") // underscore -> space
//       .toLowerCase()
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//   };

//   // Value format (date check)
//   const formatValue = (value: any) => {
//     if (!value) return "N/A";

//     const date = new Date(value);
//     if (
//       !isNaN(date.getTime()) &&
//       typeof value === "string" &&
//       /\d{4}-\d{2}-\d{2}/.test(value)
//     ) {
//       return date.toLocaleString("en-US", {
//         year: "numeric",
//         month: "short",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//       });
//     }

//     return value.toString();
//   };

//   return (
//     <div className="table-responsive flex-fill">
//       <table className="table table-striped table-sm m-0">
//         <thead>
//           <tr>
//             {headers.map((header) => (
//               <th key={header}>{formatHeader(header)}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((row, rowIndex) => (
//             <tr key={rowIndex}>
//               {/* {headers.map((header) => (
//                           <td key={header}>{formatValue(row[header])}</td>
//                       ))} */}
//               {headers.map((header) => {
//                 const cellValue = formatValue(row[header]);

//                 return (
//                   <td
//                     key={header}
//                     title={cellValue} // tooltip
//                   >
//                     <div className="d-inline-block text-truncate"  style={{ maxWidth: "200px" }}>{cellValue}</div>
//                   </td>
//                 );
//               })}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default memo(GenericTable);
import { FC, memo, useState } from "react";

interface GenericTableProps {
  data: Record<string, any>[];
}

const GenericTable: FC<GenericTableProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return <p>No data found</p>;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>(null);

  const headers = Object.keys(data[0]);

  const formatHeader = (header: string) => {
    return header
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formatValue = (value: any) => {
    if (!value) return "N/A";

    // If value is "zilretta" (case-insensitive)
  if (typeof value === "string" && value.trim().toLowerCase() === "zilretta") {
    return "ZILRETTA";
  }
    const date = new Date(value);
    if (
      !isNaN(date.getTime()) &&
      typeof value === "string" &&
      /\d{4}-\d{2}-\d{2}/.test(value)
    ) {
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    return value.toString();
  };

  const handleSort = (key: string) => {
    setSortConfig((prev) => {
      if (prev && prev.key === key) {
        // toggle direction
        return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
      }
      return { key, direction: "asc" };
    });
  };

  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig) return 0;

    const { key, direction } = sortConfig;
    const aVal = a[key];
    const bVal = b[key];

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    if (!isNaN(Date.parse(aVal)) && !isNaN(Date.parse(bVal))) {
      const dateA = new Date(aVal).getTime();
      const dateB = new Date(bVal).getTime();
      return direction === "asc" ? dateA - dateB : dateB - dateA;
    }

    if (typeof aVal === "number" && typeof bVal === "number") {
      return direction === "asc" ? aVal - bVal : bVal - aVal;
    }

    return direction === "asc"
      ? aVal.toString().localeCompare(bVal.toString())
      : bVal.toString().localeCompare(aVal.toString());
  });

  return (
    <div className="table-responsive flex-fill">
      <table className="table table-striped table-sm m-0">
        <thead>
          {/* <tr>
            {headers.map((header) => {
              const isActive = sortConfig?.key === header;
              const arrow =
                isActive && sortConfig?.direction === "asc"
                  ? "▲"
                  : isActive
                  ? "▼"
                  : "";

              return (
                <th
                  key={header}
                  onClick={() => handleSort(header)}
                  style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  {formatHeader(header)}{" "}
                  <span style={{ fontSize: "0.8em", opacity: 0.7 }}>{arrow}</span>
                </th>
              );
            })}
          </tr> */}
          <tr className="text-center align-items-center">
            {headers.map((header, index) => {
              const isActive = sortConfig?.key === header;
              const isSortable = header !== ""; // or whatever logic defines sortable headers

              return (
                <th
                  key={index}
                  onClick={isSortable ? () => handleSort(header) : undefined}
                >
                  <span
                    role={isSortable ? "button" : "textbox"}
                    className={
                      isSortable
                        ? "btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold"
                        : "fw-bold fs-6 lh-base"
                    }
                  >
                    {formatHeader(header)}
                    {isActive ? (
                      <i
                        className={`bi ${sortConfig?.direction === "desc"
                            ? "bi-caret-down-fill"
                            : "bi-caret-up-fill"
                          } ms-1`}
                      ></i>
                    ) : null}
                  </span>
                </th>
              );
            })}
          </tr>

        </thead>
        <tbody>
          {sortedData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((header) => {
                const cellValue = formatValue(row[header]);
                return (
                  <td key={header} title={cellValue}>
                    <div
                      className="d-inline-block text-truncate"
                      style={{ maxWidth: "200px" }}
                    >
                      {cellValue}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(GenericTable);
